import React from 'react';
import './HomePricingSection.css';
import { useNavigate } from 'react-router-dom';
import { 
  FaUsers, 
  FaBriefcase, 
  FaBuilding,
  FaCheck,
  FaArrowRight 
} from 'react-icons/fa';

const PricingPackages = () => {
  const navigate = useNavigate();
  const handleRecruit = () => navigate('/access-recruit');

  const packages = [
    {
      id: 1,
      type: 'STARTER PACKAGE',
      title: 'HR Essentials',
      price: '12',
      icon: <FaUsers className="prico-react-icon" />,
      features: [
        'Employee database management',
        'Basic attendance tracking',
        'Leave management system',
        'Document storage (5GB)',
        'Email support'
      ],
      bgColor: 'light',
      iconBg: '#c62828'
    },
    {
      id: 2,
      type: 'PROFESSIONAL PACKAGE',
      title: 'Complete HR Suite',
      price: '55',
      icon: <FaBriefcase className="prico-react-icon" />,
      features: [
        'Everything in Starter',
        'Payroll management',
        'Performance reviews & analytics',
        'Recruitment & onboarding',
        'Advanced reporting',
        'Priority support'
      ],
      bgColor: 'white',
      iconBg: '#c62828',
      featured: true
    },
    {
      id: 3,
      type: 'ENTERPRISE PACKAGE',
      title: 'Advanced HR Platform',
      price: '112',
      icon: <FaBuilding className="prico-react-icon" />,
      features: [
        'Everything in Professional',
        'Custom workflows & automation',
        'AI-powered insights',
        'Multi-location support',
        'Unlimited document storage',
        'Dedicated account manager'
      ],
      bgColor: 'light',
      iconBg: '#c62828'
    }
  ];

  const handleBuyNow = (packageId) => {
    console.log(`Buying package ${packageId}`);
    // Add your purchase logic here
  };

  return (
    <section className="prico-section">
      <div className="prico-container">
        {/* Section Header */}
        <div className="prico-header">
          <div className="prico-badge">WHAT CAN WE OFFER</div>
          <h2 className="prico-title">
            <span className="prico-title-highlight">Humanex</span>
            <br />
            Packages & Pricing
          </h2>
        </div>

        {/* Pricing Cards */}
        <div className="prico-grid">
          {packages.map((pkg) => (
            <div
              key={pkg.id}
              className={`prico-card ${
                pkg.bgColor === 'primary' ? 'prico-card--featured' : ''
              }`}
            >
              {/* Icon */}
              <div 
                className="prico-icon"
                style={{ backgroundColor: pkg.iconBg }}
              >
                <div className="prico-react-icon-wrapper">
                  {pkg.icon}
                </div>
              </div>

              {/* Package Info */}
              <div className="prico-card-header">
                <div className="prico-type">{pkg.type}</div>
                <h3 className="prico-name">{pkg.title}</h3>
              </div>

              {/* Price */}
              <div className="prico-price">
                <span className="prico-currency">$</span>
                <span className="prico-amount">{pkg.price}</span>
              </div>

              {/* Features List */}
              <ul className="prico-features">
                {pkg.features.map((feature, index) => (
                  <li key={index} className="prico-feature">
                    <FaCheck className="prico-check-icon" />
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>

              {/* Buy Button */}
              <button
                className={`prico-button ${
                  pkg.bgColor === 'primary'
                    ? 'prico-button--dark'
                    : 'prico-button--red'
                }`}
                onClick={handleRecruit}
              >
                Buy now
                <FaArrowRight className="prico-button-arrow-icon" />
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PricingPackages;